import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "statistics__content label-s" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.module.items.length) + " " + _toDisplayString(_ctx.$t(`common.total_of`)) + " " + _toDisplayString(_ctx.module.count ?? '*') + " " + _toDisplayString(_ctx.$t(`common.in_total`)), 1),
    _hoisted_2
  ]))
}